<section class="contact-information">
  <div class="contact-information__header">
    <div class="contact-information__header-row">
      <div class="contact-information__title-wrapper">
        <h2 class="contact-information__title">Contact Information</h2>
        <button
          *ngIf="canEdit"
          type="button"
          class="contact-information__edit-btn"
          (click)="requestEditContacts()"
          aria-label="Edit Contact Information"
        >
          <span class="material-symbols-outlined" aria-hidden="true">edit</span>
        </button>
      </div>
      <div class="contact-information__actions" *ngIf="isAnyContactEditing || isAddingContact">
        <app-az-button
          label="Discard"
          variant="default"
          [showIcon]="false"
          [disabled]="isSavingNewContact"
          (click)="handleDiscard()"
        />
        <app-az-button
          label="Save Changes"
          variant="primary"
          [showIcon]="false"
          [disabled]="getDisableSaveButton()"
          (click)="handleSave()"
        />
      </div>
    </div>
    <p class="contact-information__subtitle">
      Manage the contacts associated with the legal entity.
    </p>
  </div>

  <div class="contact-information__fields">
    <!-- Loop through all existing contacts -->
    <div
      class="contact-information__contact-wrapper"
      *ngFor="let contact of contactRows; let i = index"
    >
      <h3 class="contact-information__contact-label">CONTACT {{ contactRows.length - i }}</h3>
      <div class="contact-information__row">
        <app-form-field
          label="Contact Name:"
          [value]="contact.isEditing ? contact.currentContactName : contact.contactName"
          [disabled]="!contact.isEditing"
          (valueChange)="onContactNameChange(contact, $event)"
        />
        <div class="contact-information__field-wrapper">
          <app-form-field
            label="*Contact Email:"
            [value]="contact.isEditing ? contact.currentContactEmail : contact.contactEmail"
            [disabled]="!contact.isEditing"
            type="email"
            (valueChange)="onContactEmailChange(contact, $event)"
          />
          <span class="contact-information__error" *ngIf="hasInvalidEmail(contact)">
            Please enter a valid email address
          </span>
        </div>
        <app-form-field
          label="Phone:"
          [value]="contact.isEditing ? contact.currentPhone : contact.phone"
          [disabled]="!contact.isEditing"
          type="tel"
          (valueChange)="onPhoneChange(contact, $event)"
        />
      </div>
    </div>

    <!-- New Contact Row -->
    <div class="contact-information__row contact-information__row--new" *ngIf="isAddingContact">
      <app-form-field
        label="Contact Name:"
        [value]="newContactName"
        [disabled]="false"
        (valueChange)="onNewContactNameChange($event)"
      />
      <div class="contact-information__field-wrapper">
        <app-form-field
          label="*Contact Email:"
          [value]="newContactEmail"
          [disabled]="false"
          type="email"
          (valueChange)="onNewContactEmailChange($event)"
        />
        <span class="contact-information__error" *ngIf="hasInvalidNewEmail">
          Please enter a valid email address
        </span>
      </div>
      <app-form-field
        label="Phone:"
        [value]="newContactPhone"
        [disabled]="false"
        type="tel"
        (valueChange)="onNewContactPhoneChange($event)"
      />
    </div>

    <div class="contact-information__add-contact" *ngIf="canEdit">
      <app-az-button
        data-testid="bcr-232-add-contact-btn"
        label="Add Contact"
        variant="default"
        [showIcon]="false"
        [disabled]="isAddingContact || isAnyContactEditing"
        (click)="requestAddContact()"
      />
    </div>
  </div>
</section>

<!-- Contact Adding Processing Modal -->
<app-status-change-modal
  [isOpen]="showContactProcessingModal"
  [title]="'Adding Contact'"
  [initialState]="'processing'"
  (close)="closeContactProcessingModal()"
></app-status-change-modal>

<!-- Contact Added Success Modal -->
<app-status-change-modal
  [isOpen]="showContactSuccessModal"
  [title]="'Contact Added'"
  [initialState]="'success-with-message'"
  [successMessage]="'The contact has been successfully added to the Legal Entity'"
  [warningMessage]="'The new contact might not have access to the BCR Portal. Please add them as a Portal User via SailPoint'"
  [warningLinkText]="'SailPoint'"
  [warningLinkUrl]="'https://astrazeneca.identitynow.com/ui/d/mysailpoint'"
  (close)="closeContactSuccessModal()"
></app-status-change-modal>

<!-- Compliance Warning Modal — BCR-232 -->
<app-status-change-modal
  data-testid="bcr-232-russia-warning-modal"
  [isOpen]="showComplianceWarningModal"
  [title]="'Compliance Warning'"
  [initialState]="'custom-confirm'"
  [hideButtons]="true"
  [customMessage]="'Please do not add users based in Russia as Legal Entity Contacts, as they are restricted by Adobe from participating in the document signing process.'"
  (close)="closeComplianceWarningModal()"
></app-status-change-modal>
